module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightCondIt.9542770.eot";